export * from './src/doc-gen-api'


        import * as me from '@peachy/doc-gen-pure'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/doc-gen/pure'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/doc-gen-pure'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    